module.exports = __webpack_public_path__ + "static/media/c1.0b38262f.jpg";